/**
 * List of invisible unicode characters.
 */
export const invisibleUnicodeCharacters = [
  '\0-\x08',
  '\u000B',
  '\u000C',
  '\u000E-\u001F',
  '\x7F-\u0084',
  '\u0086-\x9F',
  '\u00A0',
  '\xAD',
  '\u200B-\u200F',
  '\u202A-\u202E',
  '\u2060-\u206F',
  '\u2072',
  '\uFEFD-\uFF00',
  '\uFFEF-\uFFFB',
];

/**
 * List of words blocked by LINE.
 */
export const NGWords = [
  ...allPermutations('LINE', 'line'),
  ...allPermutations('ライン', 'らいん'),
  ...allPermutations('ＬＩＮＥ', 'ｌｉｎｅ'),
];

/**
 * Returns all permutations of the given words.
 * @example allPermutations('LINE', 'line') => ['LINE', 'line', 'Line', 'lINE', 'lIne', 'liNE', 'linE', 'LiNE', 'liNe', 'LInE']
 * @param a
 * @param b
 * @returns
 */
function allPermutations(a: string, b: string) {
  const letters = a.split('');
  const permCount = 1 << a.length;
  const result: string[] = [];

  for (let perm = 0; perm < permCount; perm++) {
    letters.reduce((perm, _, i) => {
      letters[i] = perm & 1 ? a[i] : b[i];
      return perm >> 1;
    }, perm);

    result.push(letters.join(''));
  }

  return result;
}
